export enum IntegrationProvider {
    RentManager = 0,
    Yardi = 1
}
export class PmsProperty {
    propertyId: any;
    name: string;
}

export class PmsPropertyMapping {
    id: number;
    riqClientLocationId: number;
    pmsLocationId: any;
    pmsClientId: string;
}